import { render, staticRenderFns } from "./SuspensionApproval.vue?vue&type=template&id=54298958&scoped=true"
import script from "./SuspensionApproval.vue?vue&type=script&lang=js"
export * from "./SuspensionApproval.vue?vue&type=script&lang=js"
import style0 from "./SuspensionApproval.vue?vue&type=style&index=0&id=54298958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54298958",
  null
  
)

export default component.exports